import { useQuery } from '@tanstack/react-query';
import { Modal } from '../../../components/ui/Modal.jsx';
import { Skeleton } from '../../../components/ui/Skeleton.jsx';
import { Badge } from '../../../components/ui/Badge.jsx';
import { ragApi } from '../../../api/rag.js';
import { fmt } from '../../../lib/formatters.js';

export function ChunksDrawer({ open, onClose, document }) {
  const query = useQuery({
    queryKey: ['rag', 'chunks', document && document._id],
    enabled: open && Boolean(document && document._id),
    queryFn: () => ragApi.listChunks(document._id, { limit: 50 })
  });

  const items = (query.data && query.data.items) || [];

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={document ? `Chunk di "${document.title}"` : 'Chunk'}
      description={document ? `${document.chunkCount ?? items.length} chunk indicizzati.` : null}
      size="xl"
    >
      {query.isLoading ? (
        <div className="flex flex-col gap-2">
          {Array.from({ length: 5 }).map((_, i) => <Skeleton key={i} className="h-16 w-full" />)}
        </div>
      ) : items.length === 0 ? (
        <p className="text-sm text-ink-muted">Nessun chunk indicizzato per questo documento.</p>
      ) : (
        <ol className="flex flex-col gap-3">
          {items.map((c, idx) => (
            <li key={c._id} className="rounded-md border border-border bg-surface p-3 text-sm">
              <div className="mb-1 flex items-center justify-between text-xs text-ink-muted">
                <span>Chunk #{c.position ?? idx + 1}</span>
                <span className="flex items-center gap-2">
                  {c.active ? <Badge tone="success">attivo</Badge> : <Badge>archiviato</Badge>}
                  {c.tokens ? <span>{fmt.int(c.tokens)} token</span> : null}
                </span>
              </div>
              <p className="whitespace-pre-wrap text-ink">{c.content}</p>
            </li>
          ))}
        </ol>
      )}
    </Modal>
  );
}
